import { render, staticRenderFns } from "./card.vue?vue&type=template&id=8c5b590a&scoped=true"
import script from "./card.vue?vue&type=script&lang=js"
export * from "./card.vue?vue&type=script&lang=js"
import style0 from "./card.vue?vue&type=style&index=0&id=8c5b590a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5b590a",
  null
  
)

export default component.exports